import { useConst } from './useConst';
import { useId as useReactId } from 'react';

export const useId = (prefix?: string) => {
    const reactId = useReactId();
    const id = (prefix ?? 'id') + reactId;
    return useConst(id);
};
